import Link from "@client/controls/Link/container";
import { useI18n } from "@common/hooks/i18n";
import classnames from "classnames";
import * as React from "react";
import { type Search } from "../types";

const Item = (props: Search.SearchItem) => (
  <div className="item">
    <Link to={props.path}>{props.path}</Link>
    <h4>
      <Link to={props.path} dangerouslySetInnerHTML={{ __html: props.title }} />
    </h4>
    <p dangerouslySetInnerHTML={{ __html: props.description }} />
  </div>
);

export type MapProps = {
  isLoading: boolean;
  items: Search.SearchItem[];
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <div className={classnames("items", { loading: props.isLoading })}>
      {!props.isLoading && !props.items.length && <div className="no_results">{i18n.infoNoResults}</div>}

      {props.items.map((item, i) => (
        <Item key={i} {...item} />
      ))}
    </div>
  );
};
